import { FeatureService, FeatureServiceModule } from '@b2b/common/services/feature/feature.service';
import { PermissionsService } from '@b2b/common/services/permissions';
import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IScope } from 'angular';
import {
  CustomersIndividualsListService,
  CustomersIndividualsListServiceModule,
} from '../list/services/customers-individuals-list.service';

class CustomersIndividualsController {
  static $inject = ['$scope', '$state', 'FeatureService', 'PermissionsService', 'CustomersIndividualsListService'];

  constructor(
    private $scope: IScope & { customersIndividuals: TODO },
    private $state: StateService,
    private featureService: FeatureService,
    private permissionsService: PermissionsService,
    private customersIndividualsListService: CustomersIndividualsListService,
  ) {
    this.$scope.customersIndividuals = {
      createOrder: (customer: TODO) => this.createOrder(customer),
    };
  }

  $onDestroy() {
    this.customersIndividualsListService.reset();
  }

  /**
   * Creates a modal forking option for purchasing as a customer for an org or an individual
   */
  createOrder(customer: TODO) {
    if (this.featureService.isEnabled(this.featureService.customers) && customer.orgId) {
      if (this.permissionsService.check(['CUSTOMERS_CREATE_ORGANIZATION_ORDER'])) {
        this.featureService.customers.prompt(customer);
      } else {
        this.$state.go('application.orders.create', { customerId: customer.id });
      }
    } else {
      this.$state.go('application.orders.create', { customerId: customer.id });
    }
  }
}

export const CustomersIndividualsComponentModule = angular
  .module('acme.view.application.customers.individuals.controllers', [
    uiRouter,
    'ui.bootstrap',
    FeatureServiceModule,
    'acme.common.service.permissions',
    CustomersIndividualsListServiceModule,
  ])
  .component('acmeCustomersIndividuals', {
    templateUrl: 'views/application/views/customers/individuals/individuals.tpl.html',
    controller: CustomersIndividualsController,
    bindings: {},
  }).name;
